export const LOCATION = {
  ANY: { ID: 0 },
  MOSCOW_AND_AREA: { ID: -1 },
  SPB_AND_AREA: { ID: -2 },
  ROSTOV: { ID: 4959 },
  NOVOROSSIYSK: { ID: 4896 },
  YAROSLAVL: { ID: 5075 },
  KALUGA: { ID: 4780 },
  OBNINSK: { ID: 4908 },
  PERM: { ID: 4927 },
  EKB: { ID: 4743 },
  TYUMEN: { ID: 5024 },
  VLADIVOSTOK: { ID: 4701 },
  YUZHNOSAHALINSK: { ID: 5069 },
  NIZHNIYNOVGOROD: { ID: 4596 },
  KAZAN: { ID: 4777 },
  BLAGOVESHCHENSK: { ID: 4683 },
  KHABAROVSK: { ID: 5039 },
  ULAN_UDE: { ID: 5026 },
} as const;
